import en from "@/localization/en.json";
import { useState } from "react";
import TabBar from "./Tabbar";
import Info from "./info";
import Questions from "./questions";
import ProductReviewSection from "../sections/ProductReview";
import ItemTab from "./responsive-view/ItemTab";

import { useGetProductQuestionList } from "@/api/client/product";
import { useEffect } from "react";
import ProductQuestionModal from "../modal/product-question";

function ItemsDetails({ product }) {
  const [activeTab, setActiveTab] = useState("details");
  const [productQuestionData, setProductQuestionsData] = useState(
    product?.questions || []
  );
  const [currentQuestionPage, setCurrentQuestionPage] = useState();
  const totalRatingCount = product?.reviews.total_rating_count;
  const totalQuestionCount = product?.questions?.total_question_count;

  const { refetch: fetchQuestionData, isFetching: isQuestionFetching } =
    useGetProductQuestionList(product.slug, currentQuestionPage, {
      onSuccess: (questionData) => {
        setProductQuestionsData(questionData);
      },
      enabled: false,
    });

  useEffect(() => {
    setActiveTab("details");
    setProductQuestionsData(product?.questions);
  }, [product]);

  useEffect(() => {
    if (!currentQuestionPage) return;
    fetchQuestionData();
  }, [currentQuestionPage]);

  const tabsData = [
    { value: "details", label: "Details" },
    {
      value: "question",
      label: `Questions ${
        totalQuestionCount > 0 ? `(${totalQuestionCount})` : ""
      }`,
    },
    {
      value: "review",
      label: `Reviews ${totalRatingCount > 0 ? `(${totalRatingCount})` : ""}`,
    },
  ];

  const renderedComponent = {
    details: <Info productDetails={product?.long_desc} />,
    question: (
      <Questions
        productQuestionData={productQuestionData}
        getPaginatedQuestionData={(page) => setCurrentQuestionPage(page)}
        isQuestionFetching={isQuestionFetching}
      />
    ),
    review: <ProductReviewSection productReviewData={product?.reviews} />,
  };

  return (
    <div>
      <div className="mb-[5.313rem]">
        <h2 className="text-[1.25rem] text-[#0A101A] mb-[2.5rem]">
          {en["product.about_this_item"]}
        </h2>

        <div className="hidden md:block ml-[1.25rem]">
          <TabBar
            tabs={tabsData}
            activeTab={activeTab}
            handleActiveTab={(data) => setActiveTab(data)}
          />

          <div>{renderedComponent[activeTab]}</div>
        </div>

        <div className="block space-y-8 md:hidden">
          {tabsData.map((tab) => (
            <ItemTab
              key={tab.value}
              title={tab.label}
              isOpen={activeTab === tab.value}
              onOpen={() => setActiveTab(tab.value)}
            >
              <div>{renderedComponent[activeTab]}</div>
            </ItemTab>
          ))}
        </div>
      </div>
      <ProductQuestionModal product_slug={product.slug} />
    </div>
  );
}

export default ItemsDetails;
